<template>
  <div class="sticky">
    <div class="p-0 md:p-5 bg-white" :class="classObj + `${!sidebar ? ' w-full' : ''}`">

      <div v-if="shouldShowCloseCta" class="flex items-center justify-between relative p-3">
        <button @click="closeIframeView" class="cursor-pointer p-3 border-none bg-transparent">
          <feather-icon icon="ArrowLeftIcon" class="text-primary2" />
        </button>
        <template v-if="showTitle">
          <h1 class="text-xl font-semibold"> Resource Hub </h1>
        </template>
        <template v-if="shouldShowCartInHeader">
          <cart-drop-down />
        </template>
      </div>

      <vs-navbar v-if="shouldShowNavbar" class="vx-navbar navbar-custom navbar-skelton shop-nav relative"
        :color="navbarColorLocal"
        :class="{ 'p-0': isShopPages, textColor, 'px-0': isCreateOrUpdateAftercareDocs || isCreateOrUpdateConsentPage }">
        <div class="flex justify-between items-center w-full padder z-40 bg-white" style="height:46px;"
          :class="{ 'shop-header-top px-5 pt-4': isShopPages, 'xl:justify-end': !(isShopPages || isCreateOrUpdateAftercareDocs || isCreateOrUpdateConsentPage), 'pt-8 lg:pt-0 md:pt-0': isCreateOrUpdateAftercareDocs || isCreateOrUpdateConsentPage }">
          <div class=" flex">

            <feather-icon v-if="sidebar && !isIframe" class="sm:inline-flex xl:hidden cursor-pointer p-2 pl-0  text-primary2 " icon="MenuIcon"
              @click.stop="showSidebar"
              :class="{ 'pl-5': isCreateOrUpdateAftercareDocs || isCreateOrUpdateConsentPage, 'shop-mobile-hide': isShopPages }" />
            <div v-if="isShopPages" class="shop-logo-hit md:hidden vx-logo cursor-pointer flex items-center"
              @click="redirectToShopHome">
              <img class="mr-2 fill-current text-primary" style="width: 28px"
                :src="require('../../../../../public/Group-543.svg')" />
              <img :src="require('../../../../../public/Group-544.svg')" width="100px" />
            </div>
          </div>
          <div v-if="isShopPages" class="hidden flex-col ease-in duration-300 md:flex mr-4">
            <ClinicSwap title="Delivery to" />
          </div>

          <SearchInput v-if="isShopPages" class="hidden md:flex w-full" />

          <div class="flex flex-row justify-items-end items-center"
            :class="{ 'pr-5': (isCreateOrUpdateConsentPage || isCreateOrUpdateAftercareDocs) }">
            <whats-new v-if="!isV2Platform" :class="isShopPages ? 'shop-mobile-hide ml-1' : ''"></whats-new>

            <template v-if="shouldShowNavbar">
              <cart-drop-down v-if="showCart" class="shop-cart-slot" />
            </template>
            <org-owner-notification-drop-down v-if="!isV2Platform" :class="{ 'shop-mobile-hide': isShopPages }" />
            <org-owner-profile-drop-down v-if="showUserDropdown && !isV2Platform" :class="{ 'shop-mobile-hide': isShopPages }" />
          </div>
        </div>

        <!-- consent form -->
        <div v-if="isCreateOrUpdateConsentPage" class="w-full">
          <vs-divider v-if="!consentFormSubmissionCompleted"></vs-divider>
          <ConsentFormNavbar />
        </div>
        <!-- end consent form -->

        <!-- aftercare form -->
        <div v-if="isCreateOrUpdateAftercareDocs" class="w-full">
          <vs-divider v-if="!aftercareFormSubmissionCompleted"></vs-divider>
          <AftercareNavbar />
        </div>
        <!-- end aftercare form -->

        <div class="shop-mobile-stack w-full md:hidden" v-if="isShopPages">
          <SearchInput class="shop-search-field w-full" />
          <Navbar class="border-0" />
        </div>

        <vs-divider v-if="isShopPages && shouldShowNavbar" class="hidden md:block" />
        <Navbar v-if="isShopPages && shouldShowNavbar" class="hidden md:block border-0 pt-3" />
        <div id="deliver_to" class="shop-deliver-to md:hidden" v-if="isShopPages">
          <ClinicSwap title="Deliver to" />
        </div>

        <OrgOwnerAlertBanner id="alert_banner_mobile" class=" " v-if="isShopPages" />


      </vs-navbar>
    </div>
  </div>
</template>
<script>

import OrgOwnerNotificationDropDown from '../components/org-owner/OrgOwnerNotificationDropDown.vue';
import OrgOwnerProfileDropDown from '../components/org-owner/OrgOwnerProfileDropDown.vue';
import CartDropDown from '../components/org-owner/ClinicCartDropDown.vue';
import { mapActions } from 'vuex';
import { isShopRoute } from '@/utils/isShopRoute';
import ClinicSwap from '../../../../views/components/shop/clinic.vue';
import SearchInput from '../../../../views/components/shop/Search.vue';
import Navbar from '../../../../views/components/shop/Navbar.vue';
import OrgOwnerAlertBanner from '../../alert-banner/orgOwnerAlertBanner.vue';
import AftercareNavbar from '../../../../views/components/aftercare/Navbar.vue';
import ConsentFormNavbar from '../../../../views/components/consent-forms/Navbar.vue';
import WhatsNew from '@/layouts/components/navbar/components/WhatsNew.vue';
import iframeDetectionMixin from '@/mixins/iframeDetectionMixin';

export default {
  name: 'TheOrgOwnerNavbarVertical',
  mixins: [iframeDetectionMixin],
  data: () => ({
    clinicCompanyName: '',
    showCart: false,
    isIframe: false,
    showTitle: false,
    iframeSource: null,
  }),
  props: {
    navbarColor: {
      type: String,
      default: '#fff',
    },
    sidebar: {
      type: Boolean,
      default: true,
    },
    showUserDropdown: {
      type: Boolean,
      default: true,
    },
    showCloseCta: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    CartDropDown,
    OrgOwnerNotificationDropDown,
    OrgOwnerProfileDropDown,
    ClinicSwap,
    SearchInput,
    Navbar,
    OrgOwnerAlertBanner,
    ConsentFormNavbar,
    AftercareNavbar,
    WhatsNew,
  },
  computed: {
    navbarColorLocal() {
      return this.$store.state.theme === 'dark' && this.navbarColor === '#fff'
        ? '#10163a'
        : this.navbarColor;
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    textColor() {
      return {
        'text-white':
          (this.navbarColor != '#10163a' &&
            this.$store.state.theme === 'dark') ||
          (this.navbarColor != '#fff' && this.$store.state.theme !== 'dark'),
      };
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },

    // NAVBAR STYLE
    // eslint-disable-next-line vue/return-in-computed-property
    classObj() {
      if (this.verticalNavMenuWidth == 'default') return 'navbar-default';
      else if (this.verticalNavMenuWidth == 'reduced') return 'navbar-reduced';
      else if (this.verticalNavMenuWidth) return 'navbar-full';
    },
    isShopPages() {
      return isShopRoute(this.$route && this.$route.path);
    },
    baseUrl: function () {
      const host = window.location.protocol + '//' + window.location.host;
      const userPath = `${this.$route.path}`.split('/')[1];
      return `${host}/${userPath}`;
    },
    isCreateOrUpdateConsentPage() {
      if (!`${this.$route.path}`.includes('/consent-forms')) return false;
      return `${this.$route.path}`.includes('/create') || `${this.$route.path}`.includes('/details');
    },
    consentFormSubmissionCompleted() {
      return this.$store.getters['consentForms/isSubmissionCompleted'];
    },
    isCreateOrUpdateAftercareDocs() {
      if (!`${this.$route.path}`.includes('/aftercare')) return false;
      return `${this.$route.path}`.includes('/create') || `${this.$route.path}`.includes('/details');
    },
    aftercareFormSubmissionCompleted() {
      return this.$store.getters['aftercare/isSubmissionCompleted'];
    },
    isV2Platform() {
      return this.iframeSource === process.env.VUE_APP_V2_PLATFORM_SOURCE;
    },
    shouldShowNavbar() {
      return !this.isIframe || this.isV2Platform;
    },
    shouldShowCloseCta() {
      return this.showCloseCta && !this.isV2Platform;
    },
    shouldShowCartInHeader() {
      return this.isIframe && this.showCart && !this.isV2Platform;
    },
  },
  methods: {
    closeIframeView() {
      const windowTemp = window;
      windowTemp.webkit.messageHandlers.jsMessageHandler.postMessage(
        'close-screen'
      );
    },
    ...mapActions('appUser', ['fetchAppUserIndex']),
    redirectToShopHome() {
      const userType = JSON.parse(
        localStorage.getItem(`${process.env.VUE_APP_ACCESS_TOKEN_NAME}User`)
      ).userType;
      const role = localStorage.getItem(
        `${process.env.VUE_APP_ACCESS_TOKEN_NAME}Role`
      );

      let routerName = '';
      if (role === 'Org Owner') {
        routerName = 'OrgOwnerOrderCenter';
      } else {
        if (userType === 'doctor') {
          routerName = 'DoctorOrderCenter';
        } else {
          routerName = 'NurseOrderCenter';
        }
      }
      this.$router.push({
        name: routerName,
      });
    },

  },
  mounted() {
    this.detectIframe();

    this.showTitle = this.$route.name === 'resources';
  },
  watch: {
    '$store.state.showStore': {
      handler(val) {
        this.showCart = val;
      },
      immediate: true,
    },
    'isShopPages': {
      handler(val) {
        if (!val) {
          var element = document.getElementsByClassName('router-content');
          element[0].classList.remove('shop-alert-margin');
          element[0].classList.remove('shop-margin');
        }
      },
    },
    isIframe: {
      handler(val) {
        if (val) {
          this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false);
        }
      },
    },
  },
};
</script>

<style lang="scss">
/* Global on purpose. These selectors style layout siblings, not only this
   component. The shop scroll lock is in assets/css/shop-page-scroll.css and
   applies only when .layout--main has .is-shop-page. */
#content-area {
  background-color: white;
}

.title {
  min-height: 3rem;
}

.sticky {
  position: sticky;
  top: 0;
  z-index: 9999;
  border-bottom: 1px solid #ececec;
}

.padder {
  @media screen and (max-width: 768px) {
    padding: .8rem 1rem
  }
}

.search-wrapper {
  width: 100%;
  max-width: 600px;
}

#alert_banner_mobile {
  overflow: hidden;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  align-self: stretch;
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}

.shop-header-top {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}

@media (max-width: 767px) {
  .shop-mobile-hide {
    display: none !important;
  }

  .shop-nav.vs-navbar {
    background: #F9F7F0 !important;
  }

  .shop-header-top.padder {
    height: 48px !important;
    padding: 0 16px !important;
    background: #F9F7F0 !important;
  }

  .shop-logo-hit {
    min-height: 44px;
  }

  .shop-mobile-stack {
    background: #F9F7F0;
    padding: 12px 0;
  }

  .shop-mobile-stack .shop-search-field {
    margin: 0;
  }

  .shop-mobile-stack .nav-wrapper > nav {
    margin-top: 12px !important;
  }
}

.navbar-custom.shop-nav {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
  overflow: visible;
}

.navbar-custom {

  &.shop-nav .vs-con-items {
    @apply flex-col;
    align-items: stretch;
    width: 100%;
  }

  @media screen and (max-width: 768px) {
    border-radius: 0px !important;
    padding: 0px !important;
  }
}

@media screen and (max-width: 768px) {
  #alert_banner_mobile {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
}

.shop-wrapper {
  margin-bottom: -5rem !important;
}

.shop-wrapper-fixed-search {
  margin-bottom: 5rem !important;
}

.top-alert {
  @media (max-width: 768px) {
    top: 133px;
  }

}
</style>
